/**
 * Natures de tiers — source unique côté frontend.
 *
 * Le vocabulaire distingue deux plans :
 *   - la **typologie de litige** `transporteur` s'affiche « Transport » ;
 *   - la **nature du tiers** `transporteur` s'affiche « Transporteur »,
 *     puisqu'il s'agit ici de l'entreprise, pas de la catégorie d'incident.
 *
 * Les valeurs techniques (`fournisseur`, `transporteur`, `les_deux`) sont
 * celles du champ `kind` déjà présent en base : aucune ne change.
 */
export const KIND_LABELS = {
  fournisseur: "Fournisseurs",
  transporteur: "Transporteurs",
  les_deux: "Les deux",
};

/** Ordre d'affichage du filtre. */
export const KIND_ORDER = ["fournisseur", "transporteur", "les_deux"];

/**
 * Nature effective d'une fiche.
 *
 * Les fiches antérieures au champ `kind` n'en portent pas : elles comptent
 * comme fournisseurs, exactement comme le fait le backend. Sans cette
 * tolérance, elles seraient invisibles dans tous les segments du filtre.
 */
export function natureDe(fiche) {
  return fiche?.kind || "fournisseur";
}

/** Répartition par nature — les trois natures sont toujours présentes. */
export function repartitionParNature(fiches = []) {
  const comptes = Object.fromEntries(KIND_ORDER.map((k) => [k, 0]));
  for (const fiche of fiches) {
    const nature = natureDe(fiche);
    if (nature in comptes) comptes[nature] += 1;
  }
  return { ...comptes, all: fiches.length };
}
